/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useSuspenseQuery } from '@apollo/client';
import { ActionIcon, Avatar, Menu, rem, useMantineTheme } from '@mantine/core';

import { UserProfileForSettingDocument } from '@fai/friendli-suite/generated/client/graphql';
import { UserAvatarIcon } from '@fai/svgr';
import type { PropsWithChildren } from '@fai/util/types';

import { DropDown } from './drop-down-items';

function Target() {
  const {
    data: { clientSession },
  } = useSuspenseQuery(UserProfileForSettingDocument);

  return (
    <Menu.Target>
      <ActionIcon size={rem(40)}>
        <Avatar
          size={rem(40)}
          src={clientSession?.user.avatarUrl}
          styles={{ placeholder: { border: 'none' } }}
        >
          <UserAvatarIcon size={40} />
        </Avatar>
      </ActionIcon>
    </Menu.Target>
  );
}

function Profile({ children }: PropsWithChildren) {
  const theme = useMantineTheme();

  return (
    <Menu
      offset={{
        mainAxis: 4,
      }}
      position="bottom-end"
      shadow={theme.pf.shadow['shadow-md']}
    >
      {children}
    </Menu>
  );
}

Profile.displayName = 'Profile';

Profile.Target = Target;
Profile.DropDown = DropDown;

export default Profile;
